import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const drawerWidth = 220;

const FinanceiroLayout = () => {
  const navigate = useNavigate();

  const handleBack = () => navigate('/products');

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={handleBack} sx={{ mr: 2 }} aria-label="Voltar">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Financeiro
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <List>
          {/* --- ADICIONADO --- */}
          <ListItem button component={NavLink} to="/financeiro/dashboard">
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem button component={NavLink} to="/financeiro/contratos">
            <ListItemText primary="Contratos" />
          </ListItem>
          <ListItem button component={NavLink} to="/financeiro/receitas">
            <ListItemText primary="Receitas" />
          </ListItem>
          <ListItem button component={NavLink} to="/financeiro/despesas">
            <ListItemText primary="Despesas" />
          </ListItem>
          <ListItem button component={NavLink} to="/financeiro/despesas/cadastro">
            <ListItemText primary="Cadastro de Despesas" />
          </ListItem>
          <ListItem button component={NavLink} to="/financeiro/metas">
            <ListItemText primary="Metas" />
          </ListItem>
        </List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8, backgroundColor: '#f5f6fa', minHeight: '100vh' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default FinanceiroLayout;